import { render } from "./UserInviteModal.vue?vue&type=template&id=f1ab6180"
import script from "./UserInviteModal.vue?vue&type=script&lang=js"
export * from "./UserInviteModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__